import { z } from 'zod';
/**
 * EXEMPLE — À SUPPRIMER PAR LES PROJETS DÉRIVÉS.
 *
 * Ce contrat n'a aucune valeur métier. Il existe pour démontrer, et pour tester,
 * le trajet complet d'un schéma de validation : écrit une fois ici, il valide
 * l'entrée de l'API dans `api/src/demo/` et validerait le formulaire côté front
 * via le même import. Une règle de validation n'est jamais écrite deux fois.
 *
 * À supprimer avec `api/src/demo/` et l'entrée correspondante de `contracts/index.ts`.
 */
/**
 * `strictObject` et non `object` : `z.object` retire silencieusement les clés
 * inconnues, `z.strictObject` les refuse. C'est la posture de `CLAUDE.md` pour
 * les DTO à décorateurs — `whitelist` plus `forbidNonWhitelisted` — appliquée
 * aux schémas partagés. Un champ envoyé par erreur doit produire un 400 visible
 * en développement, pas disparaître en silence.
 */
export const demoEchoSchema = z.strictObject({
    // Le bornage n'est pas une commodité : une entrée non bornée est un vecteur de
    // déni de service. Ce motif-là reste en commentaire — il regarde qui lit le
    // code, pas qui appelle l'API. Ce que `.describe()` porte est le contrat, et
    // c'est la seule chose qui atteint OpenAPI et les fronts.
    message: z
        .string()
        .trim()
        .min(1)
        .max(280)
        .describe('Message à renvoyer. De 1 à 280 caractères.'),
    repeat: z
        .int()
        .min(1)
        .max(5)
        .default(1)
        .describe("Nombre de répétitions, de 1 à 5. Absent, vaut 1."),
});
//# sourceMappingURL=demo.contract.js.map